import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';
import { FlowSPRData } from '../../../../../services/types/Flow';
import { customDateStr } from '../../../../../shared/misc/utils';

interface Props {
  data: FlowSPRData | null;
}

const validSpr = (spr: FlowSPRData) =>
  spr != null && spr.startDate != null && customDateStr(spr.startDate.toString()) !== '01/01/0001';

const SprTable: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="history-content flow-history mb-0 table-responsive">
      <Table responsive>
        <thead>
          <tr>
            <th>{t('supervisionDates')}</th>
            <th>{t('rationale')}</th>
          </tr>
        </thead>
        <tbody>
          {data && (
            <tr>
              <td>
                {validSpr(data) &&
                  data.startDate &&
                  data.endDate &&
                  `${customDateStr(data.startDate.toString())} - ${customDateStr(
                    data.endDate.toString()
                  )}`}
              </td>
              <td>{data.rationale}</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default SprTable;
